import React from "react";
import ToggleSwitch from "../toggleSwitch";
import EditIcon from "../../icons/editIcon";
import TrashIcon from "../../icons/trashIcon";
import styles from "./style.module.css";

const ConsumableCard = ({
  item,
  index,
  handleToggleSwitch,
  track_by,
  handleEdit,
  handleDelete,
}) => {
  return (
    <div className={styles.consumable_card}>
      <div className={styles.consumable_card_head}>
        <div className={styles.consumable_card_info}>
          <div className={styles.consumable_card_info_date}>
            {`Expected Life: ${item.expectedLife}`}
          </div>
          <div className={styles.consumable_card_name}>{item.name}</div>
        </div>
        <div className={styles.consumable_card_action}>
          <button type="button" onClick={() => handleEdit(item)}>
            <EditIcon />
          </button>
          <button type="button" onClick={() => handleDelete(item)}>
            <TrashIcon />
          </button>
        </div>
      </div>
      <div className={styles.consumable_card_foot}>
        <div className={styles.consumable_card_foot_desc}>
          {`Track By: ${track_by}`}
        </div>
        <div className={styles.consumable_card_foot_toggle}>
          <ToggleSwitch
            checked={item.status === "active" ? true : false}
            index={index}
            extraPrm={item._id}
            onChange={handleToggleSwitch}
          />
        </div>
      </div>
    </div>
  );
};

export default ConsumableCard;
